/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"> <desc id="IMP.BLUE">{"#SuccessSVG":{"type":"SELECTOR","constraint":"none","width":20,"height":20},"#Vector":{"type":"SELECTOR","constraint":"none","width":11.428564071655273,"height":8.562461853027344},"transforms":{"SuccessSVG":[{"name":"SuccessSVG","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"SuccessSVG","isInstanceParent":true,"isInstanceChild":false,"width":20,"height":20}],"Vector":[{"name":"Vector","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"SuccessSVG","isInstanceParent":false,"isInstanceChild":true,"width":19.999958038330078,"height":19.999958038330078},{"name":"Vector","relativeTransforms":[[1,0,4.276896953582764],[0,1,5.723012924194336]],"rotation":0,"instanceParentName":"SuccessSVG","isInstanceParent":false,"isInstanceChild":true,"width":11.428564071655273,"height":8.562461853027344}]},"#SuccessIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":20,"height":20}}</desc>
 * <g id="SuccessIcon">
 * <g id="SuccessSVG">
 * <path id="Vector" d="M9.99998 0C4.47715 0 0 4.47715 0 9.99998C0 15.5228 4.47715 20 9.99998 20C15.5228 20 20 15.5228 20 9.99998C19.9941 4.47961 15.5204 0.00590122 9.99998 0ZM9.99998 18.5714C5.26611 18.5714 1.42856 14.7338 1.42856 9.99998C1.42856 5.26611 5.26611 1.42856 9.99998 1.42856C14.7338 1.42856 18.5714 5.26611 18.5714 9.99998C18.5663 14.7318 14.7318 18.5663 9.99998 18.5714Z" fill="#11A265"/>
 * <path id="Vector_2" d="M15.4873 5.92354C15.2105 5.65618 14.7717 5.65618 14.4949 5.92354L7.85706 12.5614L5.5049 10.2092C5.23085 9.92544 4.77863 9.91761 4.49491 10.1917C4.21115 10.4657 4.20332 10.9179 4.47738 11.2017C4.48311 11.2076 4.48897 11.2135 4.49491 11.2192L7.35207 14.0763C7.63097 14.3552 8.08315 14.3552 8.36205 14.0763L15.5049 6.93348C15.779 6.64976 15.7711 6.19759 15.4873 5.92354Z" fill="#11A265"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#SuccessSVG": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 20
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 11.428564071655273,
 * 		"height": 8.562461853027344
 * 	},
 * 	"transforms": {
 * 		"SuccessSVG": [
 * 			{
 * 				"name": "SuccessSVG",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "SuccessSVG",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 20,
 * 				"height": 20
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "SuccessSVG",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 19.999958038330078,
 * 				"height": 19.999958038330078
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						4.276896953582764
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						5.723012924194336
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "SuccessSVG",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 11.428564071655273,
 * 				"height": 8.562461853027344
 * 			}
 * 		]
 * 	},
 * 	"#SuccessIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20,
 * 		"height": 20
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const SuccessIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 20,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 20"
        >
          <G id="SuccessIcon">
            <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
              <G id="SuccessSVG">
                <Svg preserveAspectRatio="none" viewBox="0 0 20 20">
                  <Path
                    id="Vector"
                    d="M9.99998 0C4.47715 0 0 4.47715 0 9.99998C0 15.5228 4.47715 20 9.99998 20C15.5228 20 20 15.5228 20 9.99998C19.9941 4.47961 15.5204 0.00590122 9.99998 0ZM9.99998 18.5714C5.26611 18.5714 1.42856 14.7338 1.42856 9.99998C1.42856 5.26611 5.26611 1.42856 9.99998 1.42856C14.7338 1.42856 18.5714 5.26611 18.5714 9.99998C18.5663 14.7318 14.7318 18.5663 9.99998 18.5714Z"
                    fill="#11A265"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Path
                  id="Vector_2"
                  d="M15.4873 5.92354C15.2105 5.65618 14.7717 5.65618 14.4949 5.92354L7.85706 12.5614L5.5049 10.2092C5.23085 9.92544 4.77863 9.91761 4.49491 10.1917C4.21115 10.4657 4.20332 10.9179 4.47738 11.2017C4.48311 11.2076 4.48897 11.2135 4.49491 11.2192L7.35207 14.0763C7.63097 14.3552 8.08315 14.3552 8.36205 14.0763L15.5049 6.93348C15.779 6.64976 15.7711 6.19759 15.4873 5.92354Z"
                  fill="#11A265"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M9.99998 0C4.47715 0 0 4.47715 0 9.99998C0 15.5228 4.47715 20 9.99998 20C15.5228 20 20 15.5228 20 9.99998C19.9941 4.47961 15.5204 0.00590122 9.99998 0ZM9.99998 18.5714C5.26611 18.5714 1.42856 14.7338 1.42856 9.99998C1.42856 5.26611 5.26611 1.42856 9.99998 1.42856C14.7338 1.42856 18.5714 5.26611 18.5714 9.99998C18.5663 14.7318 14.7318 18.5663 9.99998 18.5714Z"
          fill="#11A265"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 20"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_2"
          d="M15.4873 5.92354C15.2105 5.65618 14.7717 5.65618 14.4949 5.92354L7.85706 12.5614L5.5049 10.2092C5.23085 9.92544 4.77863 9.91761 4.49491 10.1917C4.21115 10.4657 4.20332 10.9179 4.47738 11.2017C4.48311 11.2076 4.48897 11.2135 4.49491 11.2192L7.35207 14.0763C7.63097 14.3552 8.08315 14.3552 8.36205 14.0763L15.5049 6.93348C15.779 6.64976 15.7711 6.19759 15.4873 5.92354Z"
          fill="#11A265"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(SuccessIcon);
